import { useContext } from 'react';
import HiveContext from '../contexts/HiveContext';

const useHiveContext = () => useContext(HiveContext);

export default useHiveContext;
